module.exports = __webpack_public_path__ + "img/tadu.60064d12.png";